import { Attribute, BelongsTo, JsonApiModel, JsonApiModelConfig } from 'angular2-jsonapi'

import { OperadoraDeMaquina } from '../operadora-de-maquina.model'

@JsonApiModelConfig({
    type: 'agentes'
})
export class Agente extends JsonApiModel {
    @Attribute() usuario: string
    @Attribute() senha: string

    @BelongsTo() operadoraDeMaquina: OperadoraDeMaquina
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/estabelecimento/agente.model.ts